const ARC_REACTOR_IMG =
  "https://static.prod-images.emergentagent.com/jobs/cc691464-078d-4032-b659-09165a55600a/images/4ddf97dc88ad76864ff3e3889c1139f91e78b8355f32b37c4f015030460f1616.png";

const ArcReactorCore = () => (
  <div
    data-testid="hud-core"
    className="relative w-[140px] h-[140px] sm:w-[200px] sm:h-[200px] md:w-[260px] md:h-[260px] lg:w-[340px] lg:h-[340px] xl:w-[400px] xl:h-[400px] flex items-center justify-center"
  >
    {/* Ring 1 - Outer dashed */}
    <div className="absolute inset-0 rounded-full border border-dashed border-cyan-500/20 animate-spin-slow" style={{ willChange: "transform" }} />

    {/* Ring 2 - Inner partial */}
    <div
      className="absolute inset-[15%] rounded-full animate-spin-reverse-slow"
      style={{
        borderTop: "2px solid rgba(6,182,212,0.35)",
        borderRight: "2px solid transparent",
        borderBottom: "2px solid rgba(6,182,212,0.12)",
        borderLeft: "2px solid transparent",
        borderRadius: "9999px",
        willChange: "transform",
      }}
    />

    {/* Core image */}
    <div data-testid="arc-reactor-image" className="absolute inset-[38%] rounded-full overflow-hidden">
      <img src={ARC_REACTOR_IMG} alt="" className="w-full h-full object-cover rounded-full" />
    </div>

    {/* Center text */}
    <div data-testid="core-brand-text" className="absolute inset-0 flex flex-col items-center justify-center z-10 pointer-events-none">
      <span className="font-heading text-base sm:text-xl md:text-3xl lg:text-4xl xl:text-5xl font-black tracking-[0.2em] sm:tracking-[0.3em] text-cyan-300/80 leading-none">
        ALPHA
      </span>
      <span className="font-heading text-[5px] sm:text-[7px] md:text-[9px] lg:text-xs xl:text-sm font-bold tracking-[0.3em] sm:tracking-[0.4em] text-cyan-400/60 mt-1">
        GLOBAL ENTERPRISES
      </span>
      <span className="font-mono text-[4px] sm:text-[6px] md:text-[7px] lg:text-[9px] tracking-[0.3em] sm:tracking-[0.5em] text-cyan-500/40 mt-0.5">
        SYSTEMS ACTIVE
      </span>
    </div>
  </div>
);

export default ArcReactorCore;
